import React, { forwardRef, useId } from 'react';

import { Box } from '@betterment/samba-react';
import { token } from '@betterment/samba-styled-system/tokens';

type GradientBorderBoxProps = React.ComponentPropsWithoutRef<'div'> & {
  borderRadius?: number;
};

export const GradientBorderBox = forwardRef<HTMLDivElement, GradientBorderBoxProps>(
  ({ children, borderRadius = 8, ...props }, ref) => {
    const gradientId = useId();
    const borderColor = token('colors.border');

    return (
      <Box ref={ref} css={{ position: 'relative', width: 'fit-content' }} {...props}>
        <svg
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
          }}
        >
          <defs>
            <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#f56b0f" />
              <stop offset="25%" stopColor="#ffc729" />
              <stop offset="50%" stopColor={borderColor} />
              <stop offset="75%" stopColor="#f56b0f" />
              <stop offset="100%" stopColor="#f56b0f" />
              <animateTransform
                attributeName="gradientTransform"
                type="rotate"
                from="0 0.5 0.5"
                to="360 0.5 0.5"
                dur="6s"
                repeatCount="0"
              />
            </linearGradient>
          </defs>
          <rect
            x="0.5"
            y="0.5"
            width="calc(100% - 1px)"
            height="calc(100% - 1px)"
            rx={borderRadius}
            ry={borderRadius}
            fill="none"
            stroke={`url(#${gradientId})`}
            strokeWidth="1"
          />
        </svg>
        <Box css={{ padding: '1px' }}>{children}</Box>
      </Box>
    );
  }
);
